<template>
  <VContainer fluid class="ma-0 pa-0">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block ma-0 pa-0">
      <VRow class="ma-0 pa-0">
        <VCol
          class="pa-0 ma-0"
          cols="12"
          sm="6"
          md="8"
          style="height: 100vh !important; overflow:auto;"
        >
          <BlogArticle
            v-for="article in articles"
            :key="article.id"
            :ID="article.id"
            :Title="article.title"
            :SubTitle="article.subtitle"
            :TextBody="textArticle(article)"
            :Author="require('@/json_articles/images/' + article.id + '/' + article.foto)"
            :AuthorName="article.autor"
            :DataCreation="article.data"
            :AuthorPhoto="require('@/json_articles/autores/' + article.autor_photo)"
            :Linkedin="article.autor_id == null ? null : $getSocialNetwork(article.autor_id, 'Linkedin')"
          />
        </VCol>

        <VCol
          style="height: 100vh !important; overflow:auto;"
          class="pa-0 ma-0 search-background"
          cols="6"
          md="4"
        >
          <VRow class="px-2 py-12">
            <VCol cols="12">
              <VTextField
                class="my-input"
                prepend-inner-icon="mdi-magnify"
                variant="solo"
                v-model="searchText"
                @blur="search"
              />
            </VCol>

            <VCol cols="12">
              <VCard class="elevation-0" color="transparent">
                <VCardTitle class="text-h4 text-primary">
                  {{ $t('PRESENTATION.recent_articles') }}
                </VCardTitle>
                <VCardText>
                  <RecenteArticle
                    v-for="(article,index) in getDataArticles"
                    :key="index"
                    :ID="article.id"
                    :Title="article.title"
                    :Author="article.autor"
                    :AutorPhoto="require('@/json_articles/autores/' + article.autor_photo)"
                    :DataArticle="article.data"
                    :Photo="require('@/json_articles/images/' + article.id + '/' + article.foto)"
                    :Linkedin="article.autor_id == null ? null : $getSocialNetwork(article.autor_id, 'Linkedin')"
                  />
                </VCardText>
              </VCard>
            </VCol>
          </VRow>
        </VCol>
      </VRow>
    </div>

    <!-- MOBILE -->
    <div class="d-md-none mb-12">
      <VRow>
        <VCol
          class="pa-0 ma-0"
          cols="12"
          style="height: 100vh !important; overflow:auto;"
        >
          <BlogArticle
            v-for="article in articles"
            :key="article.id"
            :ID="article.id"
            :Title="article.title"
            :SubTitle="article.subtitle"
            :TextBody="textArticle(article)"
            :Author="require('@/json_articles/images/' + article.id + '/' + article.foto)"
            :AuthorName="article.autor"
            :DataCreation="article.data"
            :AuthorPhoto="require('@/json_articles/autores/' + article.autor_photo)"
            :Linkedin="article.autor_id == null ? null : $getSocialNetwork(article.autor_id, 'Linkedin')"
          />
        </VCol>
      </VRow>
    </div>
  </VContainer>
</template>

<script>
import BlogArticle from '@/components/Blog/BlogArticle.vue'
import RecenteArticle from '@/components/Blog/RecenteArticle.vue'
import ARTICLES from '@/json_articles/articles.json'

export default {
  name: 'Blog',
  components: { BlogArticle, RecenteArticle },

  data() {
    return {
      searchText: '',
      dataArticles: [],
      articles: []
    }
  },

  mounted() {
    this.articles = ARTICLES.articles
    this.search()
  },

  computed: {
    getDataArticles() {
      return this.dataArticles
    }
  },

  methods: {
    textArticle(t) {
      if (t.body.length > 150) return t.body.substring(0, 300) + '...'
      return t.body
    },
    search() {
      const q = (this.searchText || '').toLowerCase()
      this.dataArticles = this.articles.filter(a =>
        (a.title || '').toLowerCase().includes(q)
      )
    }
  }
}
</script>

<style>
.my-input.v-input .v-input__control {
  border-radius: 100px;
}
.search-background {
  background-color: #9DA6BA !important;
}
/* Esconder scrollbar */
::-webkit-scrollbar {
  display: none;
}
</style>
